const CUSTOMER_WAS_LOGGED_IN_KEY = "customerWasLoggedIn";

let initialAuthCheckDone = false;

export const isCustomerLoggedIn = (response) => {
  if (!response?.success || !response.psdata) {
    return false;
  }

  const data = response.psdata;
  if (data.is_logged === true || data.logged === true || data.customer_logged === true) {
    return true;
  }

  const customer = data.customer;
  if (!customer || typeof customer !== "object") {
    return false;
  }

  if (customer.is_logged === true || customer.logged === true) {
    return true;
  }

  const customerId = customer.id ?? customer.id_customer;
  return Number(customerId) > 0 && customer.is_guest !== true;
};

export const markCustomerLoggedIn = () => {
  localStorage.setItem(CUSTOMER_WAS_LOGGED_IN_KEY, "true");
};

export const clearCustomerLoggedInMark = () => {
  localStorage.removeItem(CUSTOMER_WAS_LOGGED_IN_KEY);
};

export const wasCustomerLoggedIn = () =>
  localStorage.getItem(CUSTOMER_WAS_LOGGED_IN_KEY) === "true";

export const LOGGED_OUT_MESSAGE =
  "نشست شما منقضی شده است. لطفاً مجدداً وارد حساب کاربری خود شوید.";

export const syncAuthSessionState = ({
  response,
  runInitialCheck = false,
  showMessage = null,
  clearLoggedInMark = clearCustomerLoggedInMark,
  markLoggedIn = markCustomerLoggedIn,
  message = LOGGED_OUT_MESSAGE,
}) => {
  const loggedIn = isCustomerLoggedIn(response);

  if (runInitialCheck && wasCustomerLoggedIn() && !loggedIn) {
    if (typeof showMessage === "function") {
      showMessage("warning", message, 7000);
    }
    clearLoggedInMark();
    return false;
  }

  if (loggedIn) {
    markLoggedIn();
    return true;
  }

  return false;
};

export const shouldRunInitialAuthCheck = () => {
  if (initialAuthCheckDone) {
    return false;
  }
  initialAuthCheckDone = true;
  return true;
};
